module.exports = __webpack_public_path__ + "assets/img/2.48af7a90.png";